//
//
//
//
//
//

 import {
 
 GetWechatSing
} from '../static/js/api.js'



export default {
  name: 'app',
  created(){

GetWechatSing({url: window.location.href}, function (res) {

          var sing = res.data.sing
          console.log('sing',res)
             wx.config({
                 debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                 appId:sing.appId, // 必填，公众号的唯一标识
                 timestamp: sing.timestamp, // 必填，生成签名的时间戳
                 nonceStr: sing.nonceStr, // 必填，生成签名的随机串
                 signature: sing.signature,// 必填，签名，见附录1
                 jsApiList: ['hideMenuItems','openLocation','onMenuShareTimeline','onMenuShareAppMessage'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
             });

             setTimeout(function(){

              wx.onMenuShareTimeline({
                    title: '迅豹报表', // 分享标题
                    link: 'http://www.fastleopard.cn/front/cv', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    imgUrl: 'http://www.fastleopard.cn/upload/image/20230424/20230424093852_65315.png', // 分享图标
                    success: function () {
                        // 用户点击了分享后执行的回调函数
                    }
                });

                wx.onMenuShareAppMessage({
                    title: '迅豹报表', // 分享标题
                    desc: 'Fastleopard', // 分享描述
                    link: 'http://www.fastleopard.cn/front/cv', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    imgUrl: 'http://www.fastleopard.cn/upload/image/20230424/20230424093852_65315.png', // 分享图标
                    success: function () {
                        // 用户点击了分享后执行的回调函数
                    }
                });




              wx.hideMenuItems({
               menuList: [
                 "menuItem:copyUrl",

"menuItem:editTag",

"menuItem:delete",

"menuItem:copyUrl",

"menuItem:originPage",

"menuItem:readMode",

"menuItem:openWithQQBrowser",

"menuItem:openWithSafari",

"menuItem:share:email",

"menuItem:share:brand"



               ] // 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮，所有menu项见附录3
             });
             },1000)
             

         })

}
}



// WEBPACK FOOTER //
// ./src/App.vue